<script lang="ts" context="module">
    import { writable } from "svelte/store"
    const path = writable<null | string>(null)
    export const createQuotedPiece = (newPath : string) => path.set(newPath)
    // @ts-ignore
    globalThis.createQuotedPiece = createQuotedPiece
</script>

<script lang="ts">
    import RenderItemPopup from "../templates/RenderItemPopup.svelte"
</script>

{#if $path}
    {#key path}
        <RenderItemPopup on:exit={() => ($path = null)} path={$path} />
    {/key}
{/if}
